import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import { OrderService } from "../../../services/order-service";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import moment from "moment";
// import Handlebars from 'handlebars/dist/handlebars';
import { TextField } from "@material-ui/core";

export const Ordertable = () => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "BILL_ORDERS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "BILL_ORDERS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0);
  };

  const history = useHistory();
  const [orders, setOrderDetails] = useState([]);
  const [orderID, setorderID] = useState();
  const [statusname, setStatusValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [paymentMethod, setPaymentMethodValue] = useState("");
  const [paymentStatus, setPaymentStatusValue] = useState("");
  const [courierType, setCourierTypeValue] = useState("");
  const [state, setState] = useState(false);
  const [submitloading, setSubmitLoading] = useState(true);
  const [key, setKey] = useState(0);
  const [isSending, setIsSending] = useState(false);

  const [labelHtml, setLabelHtml] = useState(null);

  const handlePrint = () => {
    const printWindow = window.open('');
    const printContent = `<html>
      <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">
        <title>Parcel Label</title>
    </head>
    <style>
        @media print {

         @page {
            size: portrait; /* 🔄 Set to landscape */
            margin: 10mm;
          }

          body {
            color: black;
          }

        .label{

                width: 4cm;
                height: 5.5cm;
                margin-top: 0.4cm;
                page-break-after: always;
            }
            /* change the margins as you want them to be. */


    }



    .label{
        width: 3.81cm;
        height: 6.35cm;
        font-size: 10pt;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: 0.4cm;
        color: black;
    }

    .orderid{
        font-size: 12pt;
    }


    .address{
        font-size: 10pt;
    }

    .website{
        font-weight: bold;
        font-size: 8pt;
    }

    .teleN p{
        line-height: 0.1cm;
    }



    </style>
    <body style="color: black;">
    ${orders.map(order => `
      <div class="container label text-center">
        <div class="textholder">
            <p class="orderid">Order ID: ${order.id}</p>
            <p class="name"> ${order.name}</p>
            <p class="address"> ${order.delivery_address}, ${order.district.name_en}</p>
            <div class="teleN">
                <p class="telone">Tel: ${order.phone1}</p>
                <p class="teltwo">Tel:  ${order.phone2}</p>
            </div>

            <p class="website">Total: Rs.${order.total}</p>
        </div>

      </div>
    `).join('')}
      <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.10.2/dist/umd/popper.min.js" integrity="sha384-7+zCNj/IqJ95wo16oMtfsKbZ9ccEh31eOz1HGyDuCQ6wgnyJNSYdrPa03rtR1zdB" crossorigin="anonymous"></script>
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.min.js" integrity="sha384-QJHtvGhmr9XOIpI6YVutG+2QOK9T+ZnN4kzFN1RtK3zEFEIsxhlmWl5/YESvpZ13" crossorigin="anonymous"></script>
      <script>
          window.print();
      </script>
      </body>
      </html>`;
    
    printWindow.document.write(printContent);
    printWindow.document.close();
    // printWindow.print();
  };

  // const handleGenerateLabel = async () => {
  //   try {
  //     // Fetch the `.hbs` file
  //     console.log('ENTER')
  //     const response = await fetch('/templates/printlabel.hbs'); // Ensure label.hbs is accessible in the public folder
  //     const hbsTemplate = await response.text();

  //     // Compile the template using Handlebars
  //     const compiledTemplate = Handlebars.compile(hbsTemplate);

  //     // Provide data for the template
  //     const order = {
  //       id: '12345',
  //       name: 'John Doe',
  //       delivery_address: '123 Street, City, Country',
  //       phone1: '0123456789',
  //       phone2: '9876543210',
  //       total: '1500',
  //     };

  //     // Generate HTML from the compiled template
  //     const html = compiledTemplate({ order });

  //     // Set the generated HTML into state
  //     setLabelHtml(html);

  //     // Open the print dialog
  //     setTimeout(() => {
  //       window.print();
  //     }, 0);
  //   } catch (error) {
  //     console.error('Error rendering label:', error);
  //   }
  // };

  const handleShow4 = (e) => {
    setState({ show4: true });
    setorderID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const clearFilters = () => {
    setStatusValue("");
    setPaymentMethodValue("");
    setPaymentStatusValue("");
    setCourierTypeValue("");
    setPage(0);
    setRowsPerPage(10);
  };

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value.trim();
    setSearchTerm(value);

  };

  const orderSearch = async () => {
    try {
      const result = await OrderService.orderDetailsBill(
        [{"searchTerm": searchTerm},{"statusname": statusname},{"paymentMethod": paymentMethod},{"paymentStatus": paymentStatus}, {"courierType": courierType}],
        rowsPerPage,
        page
      );

      // Add unique id to each order if not already present
      const ordersWithId = result.results.map((order, index) => ({
        ...order,
      }));

      setOrderDetails(ordersWithId);
      setDataCount(result?.pagination?.total);
      setKey(prevKey => prevKey + 1);
    } catch (err) {
      //toast
      console.error(err);
    }
  };


  const columns = [
    {
      field: "order_date",
      headerName: "Date",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.order_date).format(format2)}</div>;
      },
    },
    {
      field: "id",
      headerName: "Order Id",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>#{params.row.id} - {params.row.user.name} </div>;
      },
    },
    {
      field: "total",
      headerName: "Price(Rs.)",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "payment_method",
      headerName: "Payment Method",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_method === "CASH_ON_DELIVERY") {
          return (
            <div>
              {" "}
              <span>COD</span>
            </div>
          );
        } else if(params.row.payment_method === "PAYHERE") {
          return (
            <div>
              {" "}
              <span>PH</span>
            </div>
          );
        }else{
          return (
            <div>
              {" "}
              <span>BD</span>
            </div>
          );
        }
      }
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_status === "PENDING") {
          return (
            <div>
              {" "}
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.payment_status === "APPROVED") {
          return (
            <div>
              {" "}
              <span className="badge badge-success">APPROVED</span>
            </div>
          );
        } else if (params.row.payment_status === "CANCELED") {
          return (
            <div>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        } else if (params.row.payment_status === "FAILED") {
          return (
            <div>
              <span className="badge badge-primary">FAILED</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-dark">CHANGEBACK</span>
            </div>
          );
        }
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        const handleClick = () => {
          // window.open(`${window.location.origin}/edit-order/${params.row.id}`, '_blank');

        };
        if (params.row.status === "PENDING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.status === "PREPARING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-light">READY TO SHIP</span>
            </div>
          );
        } else if (params.row.status === "DELIVERING") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-secondary">SHIPPED</span>
            </div>
          );
        } else if (params.row.status === "COMPLETED") {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-success">COMPLETED</span>
            </div>
          );
        } else {
          return (
            <div onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11 mb-2">
                      <h6>Order List</h6>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Order Id"
                            fullWidth
                            margin="normal"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={searchTerm}
                            onChange={handleChangeSearchTerm}
                        />
                       </div>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15">Order Status</label>
                      <div className="input-group">
                        <select
                          name="status"
                          className="form-control"
                          value={statusname}
                          id="selectstatus"
                          required
                          onChange={(event) => {
                            setStatusValue(event.target.value);

                            // orderSearch();
                          }}
                        >
                          <option value="">- SELECT -</option>
                          <option value="PENDING">PENDING</option>
                          <option value="PREPARING">READY TO SHIP</option>
                          <option value="DELIVERING">SHIPPED</option>
                          <option value="COMPLETED">COMPLETED</option>
                          <option value="CANCELED">CANCELED</option>
                        </select>
                      </div>
                      {/* {document.getElementById("selectstatus").value} */}
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15">Courier Type</label>
                      <div className="input-group">
                        <select
                          name="currier_type"
                          className="form-control"
                          id="selectCourierType"
                          value={courierType}
                          required
                          onChange={(event) => {
                            setCourierTypeValue(event.target.value);
                          }}
                        >
                          <option value="">- SELECT -</option>
                          <option value="CURRIER">COURIER</option>
                          <option value="SL">SL POST</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15">Pay Method</label>
                      <div className="input-group">
                        <select
                          name="payment_method"
                          className="form-control"
                          id="selectPaymentmethod"
                          value={paymentMethod}
                          required
                          onChange={(event) => {
                            setPaymentMethodValue(event.target.value);
                          }}
                        >
                          <option value="">- SELECT -</option>
                          <option value="PAYHERE">PAYHERE</option>
                          <option value="CASH_ON_DELIVERY">CASH ON DELIVERY</option>
                          <option value="BANK_DEPOSIT">BANK DEPOSIT</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15">Payment Status</label>
                      <div className="input-group">
                        <select
                          name="payment_status"
                          className="form-control"
                          id="selectPaymentstatus"
                          value={paymentStatus}
                          required
                          onChange={(event) => {
                            setPaymentStatusValue(event.target.value);
                          }}
                        >
                          <option value="">- SELECT -</option>
                          <option value="PENDING">PENDING</option>
                          <option value="APPROVED">APPROVED</option>
                          <option value="CANCELED">CANCELED</option>
                          <option value="FAILED">FAILED</option>
                          <option value="CHANGEBACK">CHANGEBACK</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                        <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            onClick={orderSearch}
                          >
                          Apply Filter
                        </button>
                      </div>
                      {/* <Button onClick={orderSearch} className="btn btn-primary">
                        Apply Filter
                      </Button> */}
                    </div>
                    {/* <div className="col-md-3">
                      <label htmlFor="validationCustom15"></label>
                      <div className="input-group">
                      <button
                          type="button"
                          className="btn btn-primary shadow-none"
                          onClick={clearFilters}
                        >
                          Clear
                        </button>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div className="row row-cols-md-4 justify-content-end mb-3">
                    <div className="col text-right">
                      {/* {selectedItems && selectedItems.length > 0 ? ( */}
                          <button
                            type="button"
                            className="btn btn-dark shadow-none w-100"
                            disabled={isSending}
                            onClick={handlePrint}
                          >
                            Print&nbsp;<i className="fa fa-print" aria-hidden="true"></i>
                            {/* ({selectedItems.length})&nbsp; */}
                          </button>
                        {/* ) : (
                          <button
                            type="button"
                            className="btn btn-dark shadow-none"
                            disabled={true}
                          >
                            Send Review&nbsp;<i className="fa fa-paper-plane" aria-hidden="true"></i>
                          </button>
                      )} */}
                      {/* <div
                        id="labelContainer"
                        dangerouslySetInnerHTML={{ __html: labelHtml }}
                        style={{ display: labelHtml ? 'block' : 'none' }}
                      ></div> */}
                    </div>
                  </div>
                  <div style={{flex: "100%" }}>
                    <DataGrid
                      rows={orders}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      pageSize={100}
                      pagination
                      autoHeight
                      hideFooter
                    />
                    {/* <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ordertable;
